module.exports = __webpack_public_path__ + "media/src/assets/images/amenities_blue/safe_box-061d595a99a89c1171ac304fefeb3344.svg";